<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="TitleLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="TitleLabel" style="margin-bottom: 0">
          {{ title }}
        </h2>
        <a class="btn btn-close" aria-label="Close" (click)="_cancel()"></a>
      </div>

      <div class="container modal-body p-4">
        <form [formGroup]="form">
          <!-- name -->
          <div class="mb-3">
            <label class="form-label" for="model-name">Model Name</label>
            <input type="text" id="model-name" class="form-control" formControlName="name" required />
            @if (form.get('name').invalid) {
              <small class="form-text text-danger">Model name is
              required</small>
            }
          </div>

          <!-- description -->
          <div class="mb-3">
            <label class="form-label" for="project-description">Description</label>
            <textarea class="form-control" rows="5" id="project-description"
            formControlName="description"></textarea>
          </div>

          <!-- drop zone -->
          <div>
            <label class="form-label" for="file">Model Files</label>
            <div class="input-group mb-3">
              <shared-file-dropzone class="w-100"
                [acceptedFileTypes]="'.glb,.gltf,.bin,.png,.jpg,.jpeg,.las,.laz,.e57,.ply,.splat,.ksplat,.spz,.stl'"
                [multiple]="selectedFiles.length === 0 || isMesh"
              (filesSelected)="onFileChange($event)"></shared-file-dropzone>
            </div>

            <!-- ply options -->
            @if (hasPlyFile) {
              <div class="mb-3">
                <div class="option-group">
                  <div class="option-group-title">PLY File Type</div>
                  <div class="options">
                    <label class="option">
                      <input type="radio" name="plyType" id="plyPointCloud" [(ngModel)]="plyFileType"
                        value="pointCloud" [ngModelOptions]="{ standalone: true }" />
                        <span class="option-label">Point Cloud</span>
                      </label>
                      <label class="option">
                        <input type="radio" name="plyType" id="plySplat" [(ngModel)]="plyFileType"
                          value="splat" [ngModelOptions]="{ standalone: true }" />
                          <span class="option-label">Splat</span>
                        </label>
                      </div>
                    </div>
                  </div>
                }

                <!-- splat size warning -->
                @if (splatSizeWarning) {
                  <div class="alert alert-warning mb-3">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    {{ splatSizeWarning }}
                  </div>
                }

                <!-- center toggle -->
                @if (isPointCloud) {
                  <div class="mb-3">
                    <label class="switch">
                      <input type="checkbox" formControlName="isCentered" id="centering" />
                      <span class="slider"></span>
                      <span class="switch-text">Center Pointcloud</span>
                    </label>
                  </div>
                }

                <!-- validation -->
                @if (form.get('files').touched && (form.get('files').invalid || !selectedFiles.length)) {
                  <small
                    class="form-text text-danger">
                    At least one file is required
                  </small>
                }
              </div>

              <!-- list -->
              <ul class="list-group">
                @for (file of selectedFiles; track file; let i = $index) {
                  <li [attr.data-index]="i"
                    class="list-group-item d-flex justify-content-between align-items-center">
                    <span class="text-nowrap text-truncate" style="min-width: 0">
                      <span class="text-center"><i [ngClass]="modelService.iconClasses(file.name)"
                      style="width: 20px"></i></span>
                      <span style="padding-left: 10px">{{ file.name }}</span>
                    </span>
                    <a class="btn text-secondary" (click)="removeFile(i)"><i class="fas fa-trash"></i></a>
                  </li>
                }
              </ul>
            </form>
          </div>

          <!-- footer -->
          <div class="modal-footer">
                <button type="button" class="btn" [ngClass]="{
            'btn-primary': submitColor == 'blue' || !submitColor,
            'btn-success': submitColor == 'green',
            'btn-danger': submitColor == 'red',
            'btn-warning': submitColor == 'yellow'
          }" (click)="_submit()">
              {{ submitText }}
            </button>
            <button type="button" class="btn btn-secondary" (click)="_cancel()">
              {{ cancelText }}
            </button>
          </div>
        </div>
      </div>
    </div>